import { Component, OnInit }              from '@angular/core';
// import { ModalController, Modal }         from 'ionic-angular';
import { NavController, NavParams }       from 'ionic-angular';
import { Book }                           from "../../models/book";
import { BookService }                    from "../../services/book.service";
import { CategoryService }                from "../../services/category.service";
import { CrawlService }                   from "../../services/crawl.service";
import { MiscService }                    from "../../services/misc.service";
import { ReaderComponent }                from "../reader/reader.component";

@Component({
  selector: 'dra-book',
  templateUrl: 'book.component.html'
})
export class BookComponent implements OnInit {
  private bookAlias: string;
  private categoriesMap: Object;
  private book: Book;
  private reading;
  private isLoggedIn: boolean = true;

  public constructor(
    private navController: NavController,
    private navParams: NavParams,
    private bookService: BookService,
    private categoryService: CategoryService,
    private crawlService: CrawlService,
    private miscService: MiscService,
  ) {
  }

  public async ngOnInit(): Promise<void> {
    try {
      this.bookAlias = this.navParams.get('bookAlias');

      await this.getBook();
      await this.getCategories();

      this.reading = await this.bookService.getRecent(this.book);
    } catch (error) {
      console.log(error);
    }
  }

  public async goChapter($event?: Event, chapter?) {
    if ($event) {
      $event.preventDefault();
      $event.stopPropagation();
    }

    if (!chapter) {
      chapter = await this.bookService.getRecent(this.book);
      if (!chapter) chapter = this.book.chapters[0];
    }

    // let modal: Modal = this.modalController.create(ReaderComponent, {
    //   'bookAlias': this.book.alias,
    //   'chapterAlias': chapter.alias,
    // }, {
    //   'cssClass': 'fullscreen-modal reader-modal'
    // });
    //
    // modal.present();

    this.navController.push(ReaderComponent, {
      'bookAlias': this.book.alias,
      'chapterAlias': chapter.alias,
    });
  }

  public async getBook(crawl?: boolean, loader?): Promise<Book> {
    try {
      this.miscService.startLoading();

      // console.log(this.bookAlias);
      let book = await this.bookService.getBook(this.bookAlias, {crawl: crawl, reload: true}, true);

      console.log(book);
      this.miscService.setTitle(book.name);
      this.miscService.stopLoading();
      if (loader) loader.complete();

      return this.book = book;
    } catch (error) {
      console.error(error);
    }
  }
  public async getChapters(): Promise<any[]> {
    try {
      return this.book.chapters = await this.crawlService.getBookChapters(this.book.id);
    } catch (error) {
      console.log(error);
    }
  }
  public async getCategories(): Promise<any> {
    try {
      return this.categoriesMap = await this.categoryService.getCategories();
    } catch (error) {
      console.error(error);
    }
  }
  public async toggleBookmark(): Promise<void> {
    try {
      this.isLoggedIn && await this.bookService.toggleBookmark(this.book);
    } catch (error) {
      console.log(error);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/book/book.component.ts